<template>
  <div class="abnormal-asset">
    <h3>异常用户资产扣除</h3>
    <el-form inline size="small" @submit.native.prevent="search">
      <el-form-item><el-input v-model.trim="filter.userUid" placeholder="用户UID（精确查询）" /></el-form-item>
      <el-form-item><el-select v-model="filter.accountType" clearable placeholder="全部账户">
        <el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value" />
      </el-select></el-form-item>
      <el-form-item><el-button type="primary" @click="search">查询</el-button><el-button @click="reset">重置</el-button><el-button @click="load">刷新</el-button></el-form-item>
      <el-form-item v-if="allowed"><el-button type="primary" @click="open">扣除资产</el-button></el-form-item>
    </el-form>
    <el-alert v-if="recoveryError" type="warning" :closable="false" :title="recoveryError" />
    <div v-for="request in contractRequests" :key="request.requestKey" class="review-note">
      <span>合约扣除待核查：用户 {{ request.userUid }}，{{ request.amount }} {{ request.coin }}，{{ request.id ? '操作单号：' + request.id : '请求键：' + request.requestKey }}</span>
      <el-button type="text" :disabled="recovering || submitting || handling" @click="recoverRequest(request)">核查原请求</el-button>
    </div>
    <el-table v-loading="loading" :data="rows" border>
      <el-table-column prop="id" label="操作单号" min-width="180" />
      <el-table-column prop="userUid" label="用户UID" min-width="100" />
      <el-table-column label="账户" min-width="110"><template slot-scope="s">{{ accountName(s.row.accountType) }}</template></el-table-column>
      <el-table-column label="扣除金额" min-width="150"><template slot-scope="s">{{ s.row.amount }} {{ s.row.coin }}</template></el-table-column>
      <el-table-column label="操作时间" min-width="170"><template slot-scope="s">{{ time(s.row.createdTime) }}</template></el-table-column>
      <el-table-column prop="operator" label="操作人" min-width="100" />
      <el-table-column label="处理结果" min-width="230"><template slot-scope="s">{{ status(s.row) }}</template></el-table-column>
      <el-table-column label="操作" width="100" fixed="right"><template slot-scope="s"><el-button type="text" @click="showDetail(s.row.id, null, s.row)">查看处理</el-button></template></el-table-column>
    </el-table>
    <el-pagination
      background
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 25, 50, 100]"
      :total="total"
      layout="total, prev, pager, next, sizes, jumper"
      @current-change="pageChanged"
      @size-change="sizeChanged"
    />
    <el-dialog title="异常用户资产扣除" :visible.sync="visible" width="500px" :close-on-click-modal="false" :before-close="close">
      <el-form label-width="100px" :disabled="submitting || pending">
        <el-form-item label="用户UID" required><el-input v-model.trim="form.userUid" maxlength="19" @input="invalidate" @blur="fetchAvailable()" /></el-form-item>
        <el-form-item label="账户" required><el-select v-model="form.accountType" @change="accountChanged"><el-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value" /></el-select></el-form-item>
        <el-form-item v-if="checking || availableError || (availableLoaded && !Object.keys(balances).length)">
          <span v-if="checking"><i class="el-icon-loading" /> 正在查询可扣余额</span>
          <template v-else-if="availableError">
            <span>{{ availableError }}</span>
            <el-button type="text" @click="fetchAvailable()">重新加载</el-button>
          </template>
          <span v-else>当前账户没有可扣余额</span>
        </el-form-item>
        <el-form-item label="币种" required><el-select v-model="form.coin" :disabled="checking || !availableLoaded || !Object.keys(balances).length"><el-option v-for="coin in Object.keys(balances)" :key="coin" :value="coin" :label="coin" /></el-select></el-form-item>
        <el-form-item label="可扣余额"><el-input :value="currentBalance" readonly /></el-form-item>
        <el-form-item label="扣除金额" required><el-input v-model.trim="form.amount" placeholder="最多4位小数" :disabled="checking || !availableLoaded || !form.coin" /></el-form-item>
      </el-form>
      <el-alert v-if="pending" type="info" :closable="false" title="请求结果待确认，请刷新列表查询，勿重复扣除。" />
      <span slot="footer"><el-button :disabled="submitting" @click="close">关闭</el-button><el-button v-if="!pending" type="primary" :loading="submitting" :disabled="checking || !availableLoaded || !form.coin" @click="submit">确认</el-button></span>
    </el-dialog>
    <el-dialog title="扣除核查处理" :visible.sync="detailVisible" width="780px" :close-on-click-modal="false" :show-close="!handling" :close-on-press-escape="!handling" :before-close="closeDetail">
      <div v-loading="detailLoading || handling" v-if="operation">
        <p>操作单号：{{ operation.id }}　用户UID：{{ operation.userUid }}</p>
        <p>{{ accountName(operation.accountType) }}　扣除金额：{{ operation.amount }} {{ operation.coin }}</p>
        <p>处理结果：{{ operation.message }}　核对情况：{{ reconcileName(operation.reconcileState) }}</p>
        <p>发送情况：{{ operation.sendObservation }}</p>
        <p>用户扣款流水：{{ operation.sourceLedgerCount }} 条　公共账户入账流水：{{ operation.publicLedgerCount }} 条</p>
        <el-alert v-if="operation.reviewRequired" type="warning" :closable="false" title="请核查原单并登记处理依据；结果未知或单边流水禁止重扣，处理说明不会改变资金结果。" />
        <el-alert v-if="operation.accountType === 'CONTRACT' && detailStale" type="warning" :closable="false" title="原单结果待确认，请先刷新详情核查，再进行处理。" />
        <el-input v-if="canHandle" v-model.trim="reviewNote" type="textarea" :rows="3" maxlength="1000" show-word-limit placeholder="处理说明或工单依据（至少10字）" class="review-note" />
        <p v-if="canHandle">
          <el-button size="small" :disabled="handling" @click="handleOperation('CHECK')">重新核查</el-button>
          <el-button size="small" :disabled="handling" @click="handleOperation('NOTE')">登记处理记录</el-button>
          <el-button v-if="operation.canRetry" size="small" type="primary" :disabled="handling || detailLoading || (operation.accountType === 'CONTRACT' && detailStale)" @click="handleOperation('RETRY_NOT_SENT')">重试原单</el-button>
          <el-button v-if="operation.canCancel" size="small" :disabled="handling || detailLoading || (operation.accountType === 'CONTRACT' && detailStale)" @click="handleOperation('CANCEL_NOT_SENT')">取消未发送单</el-button>
        </p>
        <el-button v-if="canAcknowledge" :disabled="handling || detailLoading || recovering || acknowledging || detailStale" @click="acknowledgeRequest">已核对原单结果，结束本次请求</el-button>
        <p>最近100条处理记录</p>
        <el-table :data="reviews" border max-height="300">
          <el-table-column label="时间" width="165"><template slot-scope="s">{{ time(s.row.createdTime) }}</template></el-table-column>
          <el-table-column prop="operator" label="操作人" width="100" />
          <el-table-column label="操作" width="120"><template slot-scope="s">{{ actionName(s.row.action) }}</template></el-table-column>
          <el-table-column prop="note" label="处理说明" min-width="220" />
        </el-table>
      </div>
      <span slot="footer"><el-button :disabled="handling" @click="closeDetail">关闭</el-button><el-button :disabled="handling || detailLoading" @click="showDetail(detailId)">刷新</el-button></span>
    </el-dialog>
  </div>
</template>
<script>
import api from './api'
import Decimal from 'decimal.js'
import { hasPerm } from 'common/permission'
import { readRequests, readRevision, isRequestEnded, saveRequest, removeRequest } from './contractRequest'
export default {
  data() { return {
    types: [{ value: 'SPOT', label: '现货账户' }, { value: 'CONTRACT', label: '合约账户' }, { value: 'COPY', label: '跟单账户' }],
    filter: { userUid: '', accountType: '' }, page: 1, pageSize: 10, total: 0, rows: [], loading: false, listVersion: 0,
    detailVisible: false, detailLoading: false, handling: false, detailId: '', operation: null, reviews: [], reviewNote: '',
    visible: false, submitting: false, checking: false, pending: false, version: 0,
    availableLoaded: false, availableError: '',
    requestScope: '', contractRequests: [], recoveryError: '', recovering: false, acknowledging: false, detailStale: true,
    contractBalance: null, contractRequestOwner: null, contractDetailOwner: null, recoveryContextVersion: 0,
    form: { userUid: '', accountType: '', coin: '', amount: '' }, balances: {}, requestKey: '',
  } },
  computed: {
    canHandle() { return hasPerm(this.$store.state.userInfo || {}, 'tenant:abnormal_asset:handle') },
    allowed() { return hasPerm(this.$store.state.userInfo || {}, 'tenant:abnormal_asset:deduct') },
    currentBalance() { return this.balances[this.form.coin] == null ? '--' : String(this.balances[this.form.coin]) },
    canAcknowledge() {
      return this.confirmedResult(this.operation)
        && this.contractRequests.some(item => item.requestKey === this.operation.requestKey)
    },
  },
  created() { this.load(); this.initRecovery(); window.addEventListener('storage', this.readRecovery) },
  beforeDestroy() { this.version++; this.recoveryContextVersion++; this.contractRequestOwner = null; this.contractDetailOwner = null; window.removeEventListener('storage', this.readRecovery) },
  methods: {
    beginContractDetail(id, requestKey) {
      if (!this.requestScope) throw new Error('无法确认合约请求身份，请刷新页面后重试')
      const owner = { scope: this.requestScope, id: id == null ? null : String(id), requestKey,
        endedAtStart: requestKey ? isRequestEnded(this.requestScope, requestKey) : false }
      // Object identity is the detail version, including refreshes of the same operation.
      this.contractDetailOwner = owner
      return owner
    },
    ownsContractDetail(owner) {
      return owner && this.contractDetailOwner === owner && owner.scope === this.requestScope
    },
    clearContractDetail() {
      if (!this.contractDetailOwner) return
      this.contractDetailOwner = null
      this.detailLoading = false; this.handling = false; this.recovering = false; this.acknowledging = false
      this.detailVisible = false; this.detailStale = true; this.detailId = ''
      this.operation = null; this.reviews = []; this.reviewNote = ''
    },
    releaseEndedContractDetail() {
      const owner = this.contractDetailOwner
      if (!owner) return
      // Explicitly opening an already-ended historical record remains viewable.
      if (owner.scope !== this.requestScope || (!owner.endedAtStart && owner.requestKey
        && isRequestEnded(owner.scope, owner.requestKey))) this.clearContractDetail()
    },
    acceptContractDetail(owner) {
      if (!this.ownsContractDetail(owner)) return false
      try { this.releaseEndedContractDetail(); return this.ownsContractDetail(owner) }
      catch (error) {
        this.detailStale = true; this.recoveryError = error.message || '无法读取合约请求状态，请核查原单'
        return false
      }
    },
    checkContractDetail(owner, op) {
      if (!op || op.accountType !== 'CONTRACT' || !op.id || !op.requestKey
        || (owner.id && String(op.id) !== owner.id) || (owner.requestKey && op.requestKey !== owner.requestKey)) {
        throw new Error('原合约操作单核查结果不匹配，请刷新详情')
      }
      owner.id = String(op.id); owner.requestKey = op.requestKey
    },
    closeDetail(done) {
      if (this.handling) return
      this.clearContractDetail(); this.detailVisible = false
      if (typeof done === 'function') done()
    },
    ownsContractRequest(owner) {
      return owner && this.contractRequestOwner === owner && this.form.accountType === 'CONTRACT'
        && this.requestScope === owner.scope
    },
    releaseEndedContractRequest(owner = this.contractRequestOwner) {
      if (!this.ownsContractRequest(owner) || !owner.requestKey || !isRequestEnded(owner.scope, owner.requestKey)) return false
      this.contractRequestOwner = null
      this.pending = false; this.submitting = false; this.invalidate()
      this.availableError = '原合约请求已结束，请重新查询余额并确认'
      return true
    },
    acceptContractResponse(owner) {
      if (!this.ownsContractRequest(owner)) return false
      try { return !this.releaseEndedContractRequest(owner) }
      catch (error) {
        // Unreadable storage must keep the original request pending, never unlock it.
        this.recoveryError = error.message || '无法读取合约请求结束状态，请核查原单'
        return true
      }
    },
    confirmedResult(op) {
      return op && op.accountType === 'CONTRACT' && !op.reviewRequired
        && ((op.status === 'SUCCESS' && op.reconcileState === 'MATCHED')
          || (op.status === 'FAILED' && (op.reconcileState === 'REJECTED'
            || (op.reconcileState === 'NOT_SENT' && op.dispatchState === 'NOT_SENT'))))
    },
    readRecovery() {
      if (!this.requestScope) return
      try {
        this.contractRequests = readRequests(this.requestScope); this.recoveryError = ''
        this.releaseEndedContractDetail()
        if (!this.releaseEndedContractRequest() && this.form.accountType === 'CONTRACT' && this.contractBalance
          && (this.contractBalance.scope !== this.requestScope || this.contractBalance.revision !== readRevision(this.requestScope))) {
          this.invalidate()
          this.availableError = '合约扣除状态已变化，请重新查询余额并确认'
        }
      }
      catch (error) { this.recoveryError = error.message || '无法读取合约待确认请求，暂不可发起新的合约扣除' }
    },
    async initRecovery(isCurrent = () => true) {
      if (!isCurrent()) return false
      const version = ++this.recoveryContextVersion
      // Guard the helper's writes too: an obsolete caller must not change a new
      // request's identity, recovery records or warning, even on lookup failure.
      const current = () => version === this.recoveryContextVersion && isCurrent()
      try {
        const res = await api.detail({ recoveryContext: true })
        if (!current()) return false
        if (!res || res.code !== 0 || !res.data || !res.data.requestScope) throw new Error('无法确认合约请求身份，请刷新页面后重试')
        this.requestScope = res.data.requestScope
        this.readRecovery()
        return true
      } catch (error) {
        if (!current()) return false
        this.recoveryError = error.message || '合约待确认请求恢复失败，请刷新页面'
        return false
      }
    },
    async rememberContract(operation, mode, balanceStamp, isCurrent) {
      const initialized = await this.initRecovery(isCurrent)
      if (!isCurrent()) return false
      if (this.recoveryError || !this.requestScope) throw new Error(this.recoveryError || '无法保存原合约请求')
      if (!initialized) return false
      if (mode === 'new' && (!balanceStamp || balanceStamp.scope !== this.requestScope)) throw new Error('合约余额已失效，请重新查询余额并确认')
      await saveRequest(this.requestScope, operation, mode, balanceStamp && balanceStamp.revision)
      if (!isCurrent()) return false
      this.readRecovery()
      return true
    },
    async recoverRequest(request) {
      this.readRecovery()
      if (this.recovering || this.submitting || this.handling || this.detailLoading) return
      let detailOwner
      try { detailOwner = this.beginContractDetail(request.id, request.requestKey) }
      catch (error) { this.$message.error(error.message); return }
      this.recovering = true; this.detailStale = true
      const scope = this.requestScope
      try {
        const res = await api.detail({ requestKey: request.requestKey })
        if (!this.acceptContractDetail(detailOwner)) return
        if (!res || res.code !== 0 || !res.data) throw new Error(res && res.msg || '原请求核查失败')
        const op = res.data.operation
        if (!op) throw new Error('暂未查到原单，原请求可能仍在处理；请稍后再次核查，勿重新扣除。请求键：' + request.requestKey)
        if (op.accountType !== 'CONTRACT' || op.requestKey !== request.requestKey) throw new Error('原请求核查结果不匹配')
        this.checkContractDetail(detailOwner, op)
        if (scope !== this.requestScope) throw new Error('登录身份已变化，请刷新页面')
        const updated = await saveRequest(scope, op, 'update')
        this.readRecovery()
        if (!this.acceptContractDetail(detailOwner)) return
        if (!updated) { this.$message.info('原请求已在其他标签页结束，请刷新列表查看'); return }
        this.detailId = op.id; this.operation = op; this.reviews = res.data.reviews || []; this.reviewNote = ''
        this.detailStale = false; this.detailVisible = true
      } catch (error) { if (this.acceptContractDetail(detailOwner)) this.$message.error(error.message || '原请求核查失败，请稍后重试') }
      finally { if (this.ownsContractDetail(detailOwner)) this.recovering = false }
    },
    async acknowledgeRequest() {
      if (!this.canAcknowledge || this.detailStale || this.handling || this.detailLoading || this.recovering || this.acknowledging) return
      let detailOwner
      try { detailOwner = this.beginContractDetail(this.operation.id, this.operation.requestKey) }
      catch (error) { this.$message.error(error.message); return }
      this.acknowledging = true
      const key = this.operation.requestKey
      const scope = this.requestScope
      try {
        await this.$confirm('确认已核对原单最终结果？结束后再次提交将是一笔新的扣除，请勿将原单重复扣除。', '提示')
        if (!this.acceptContractDetail(detailOwner)) return
        const res = await api.detail({ requestKey: key })
        if (!this.acceptContractDetail(detailOwner)) return
        const op = res && res.code === 0 && res.data && res.data.operation
        if (!this.confirmedResult(op) || op.requestKey !== key) throw new Error('尚未确认原单最终结果，请继续核查')
        this.checkContractDetail(detailOwner, op)
        if (scope !== this.requestScope) throw new Error('登录身份已变化，请刷新页面')
        await removeRequest(scope, key)
        if (this.ownsContractDetail(detailOwner)) this.readRecovery()
      } catch (error) { if (this.acceptContractDetail(detailOwner) && error !== 'cancel' && error !== 'close') this.$message.error(error.message || '无法结束请求，请刷新核查') }
      finally { if (this.ownsContractDetail(detailOwner)) this.acknowledging = false }
    },
    reconcileName(value) { return ({ NOT_SENT: '未发送', UNKNOWN: '结果未知', ONE_SIDED: '单边流水', MATCHED: '双方流水匹配', REJECTED: '明确余额不足', CONFLICT: '证据冲突' })[value] || '--' },
    actionName(value) { return ({ CHECK: '重新核查', NOTE: '登记说明', DISPATCH: '取得发送资格', CANCEL_NOT_SENT: '取消未发送单', EVIDENCE_SUCCESS: '核实成功', EVIDENCE_FAILED: '核实失败' })[value] || value },
    async showDetail(id, contractOwner = null, record = null) {
      if (contractOwner && !this.acceptContractResponse(contractOwner)) return
      const current = this.contractDetailOwner
      const contract = contractOwner || (record && record.accountType === 'CONTRACT')
        || (current && current.id === String(id)) || (this.operation && this.operation.id === id && this.operation.accountType === 'CONTRACT')
      const requestKey = contractOwner ? contractOwner.requestKey : (record && record.requestKey)
        || (current && current.id === String(id) && current.requestKey) || (this.operation && this.operation.id === id && this.operation.requestKey)
      if (contract) {
        this.readRecovery()
        if (contractOwner && !this.acceptContractResponse(contractOwner)) return
        // A new accepted contract operation owns the next detail view, even while an
        // older contract view/handler is waiting. Never bypass a SPOT/COPY handler.
        if (contractOwner && this.contractDetailOwner && this.contractDetailOwner.requestKey !== requestKey) this.clearContractDetail()
      }
      if (this.detailLoading || this.handling || this.recovering || this.acknowledging || !id) return
      let detailOwner = null
      if (contract) {
        try { detailOwner = this.beginContractDetail(id, requestKey) }
        catch (error) { this.$message.error(error.message); return }
      } else this.clearContractDetail()
      if (this.detailId !== id) { this.operation = null; this.reviews = []; this.reviewNote = '' }
      this.detailId = id; this.detailVisible = true; this.detailLoading = true; this.detailStale = true
      try {
        const res = await api.detail({ id })
        if (detailOwner && !this.acceptContractDetail(detailOwner)) return
        if (contractOwner && !this.acceptContractResponse(contractOwner)) return
        if (!res || res.code !== 0 || !res.data) throw new Error(res && res.msg || '详情查询失败')
        if (detailOwner) {
          this.checkContractDetail(detailOwner, res.data.operation)
          if (!this.acceptContractDetail(detailOwner)) return
        }
        this.operation = res.data.operation; this.reviews = res.data.reviews || []
        this.detailStale = false
      } catch (error) { if ((!detailOwner || this.acceptContractDetail(detailOwner)) && (!contractOwner || this.acceptContractResponse(contractOwner))) this.$message.error(error.message || '详情查询失败') }
      finally { if (!detailOwner || this.ownsContractDetail(detailOwner)) this.detailLoading = false }
    },
    async handleOperation(action) {
      if (!this.canHandle || this.handling || this.detailLoading || this.recovering || this.acknowledging || !this.operation) return
      if (this.operation.accountType === 'CONTRACT' && this.detailStale && ['RETRY_NOT_SENT', 'CANCEL_NOT_SENT'].includes(action)) return this.$message.error('请先刷新核查原单结果')
      if (action !== 'CHECK' && this.reviewNote.length < 10) return this.$message.error('请填写至少10字的处理说明或工单依据')
      const contractOp = this.operation.accountType === 'CONTRACT' ? { ...this.operation } : null
      const contractNote = this.reviewNote
      let detailOwner = null
      if (contractOp) {
        try { detailOwner = this.beginContractDetail(contractOp.id, contractOp.requestKey) }
        catch (error) { this.$message.error(error.message); return }
      }
      this.handling = true
      try {
        if (action === 'RETRY_NOT_SENT' || action === 'CANCEL_NOT_SENT') {
          try { await this.$confirm(action === 'RETRY_NOT_SENT' ? '确认重试该未发送原单吗？' : '确认取消该未发送原单吗？', '提示') }
          catch (_) { return }
        }
        if (detailOwner && !this.acceptContractDetail(detailOwner)) return
        if (contractOp && action === 'RETRY_NOT_SENT') {
          if (!await this.rememberContract(contractOp, 'retry', null, () => this.acceptContractDetail(detailOwner))) return
          if (!this.acceptContractDetail(detailOwner)) return
        }
        if (contractOp) this.detailStale = true
        const res = await api.handle({ id: contractOp ? contractOp.id : this.detailId, action, note: contractOp ? contractNote : this.reviewNote })
        if (detailOwner && !this.acceptContractDetail(detailOwner)) return
        if (!res || res.code !== 0 || !res.data) throw new Error(res && res.msg || '处理结果待确认，请刷新详情')
        if (detailOwner) this.checkContractDetail(detailOwner, res.data.operation)
        this.operation = res.data.operation; this.reviews = res.data.reviews || []; this.reviewNote = ''
        this.detailStale = false
        this.$message.info(action === 'RETRY_NOT_SENT' ? this.operation.message : '处理记录已更新')
        this.load()
      } catch (error) { if (!detailOwner || this.acceptContractDetail(detailOwner)) this.$message.error(error.message || '处理结果待确认，请刷新详情') }
      finally { if (!detailOwner || this.ownsContractDetail(detailOwner)) this.handling = false }
    },
    accountName(type) { const item = this.types.find(x => x.value === type); return item ? item.label : type },
    time(value) { return value ? new Date(Number(value)).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai', hour12: false }) : '--' },
    status(row) { return row.status === 'SUCCESS' ? '扣除成功' : row.message || '结果确认中，请刷新查询' },
    validateUid(value) { return /^[1-9]\d{0,18}$/.test(value) },
    async load() {
      if (this.filter.userUid && !this.validateUid(this.filter.userUid)) return this.$message.error('请输入正确的用户UID')
      const version = ++this.listVersion
      this.loading = true
      try {
        const res = await api.page({ userUid: this.filter.userUid || undefined, accountType: this.filter.accountType || undefined, page: this.page, size: this.pageSize })
        if (version !== this.listVersion) return
        if (!res || res.code !== 0 || !res.data) throw new Error(res && res.msg || '查询失败')
        this.rows = res.data.list || []; this.total = Number(res.data.totalCount || 0)
      } catch (error) { if (version === this.listVersion) this.$message.error(error.message || '查询失败') }
      finally { if (version === this.listVersion) this.loading = false }
    },
    pageChanged(page) { if (page === this.page) return; this.page = page; this.load() },
    sizeChanged(size) { this.pageSize = size; this.page = 1; this.load() },
    search() { this.page = 1; this.load() },
    reset() { this.filter = { userUid: '', accountType: '' }; this.search() },
    open() {
      if (this.contractRequestOwner && this.submitting) return
      this.contractRequestOwner = null; this.form = { userUid: '', accountType: '', coin: '', amount: '' }
      this.pending = false; this.invalidate(); this.visible = true
    },
    close(done) { if (this.submitting) return; this.contractRequestOwner = null; this.visible = false; this.invalidate(); if (typeof done === 'function') done() },
    invalidate() {
      this.version++; this.checking = false; this.availableLoaded = false; this.availableError = ''
      this.balances = {}; this.form.coin = ''; this.form.amount = ''; this.requestKey = ''
      this.contractBalance = null
    },
    accountChanged() { this.invalidate(); return this.fetchAvailable() },
    async fetchAvailable() {
      if (this.form.accountType === 'CONTRACT') this.readRecovery()
      if (!this.visible || !this.allowed || this.submitting || this.pending || this.checking || this.availableLoaded) return
      if (!this.validateUid(this.form.userUid) || !this.form.accountType) return
      if (this.form.accountType === 'CONTRACT') {
        if (this.recoveryError || !this.requestScope || this.contractRequests.length) {
          this.availableError = this.recoveryError || '请先在列表上方核查原合约请求并确认最终结果，再发起新的扣除'
          return
        }
      }
      const version = ++this.version; this.checking = true; this.availableError = ''
      try {
        const balanceStamp = this.form.accountType === 'CONTRACT'
          ? { scope: this.requestScope, revision: readRevision(this.requestScope) } : null
        this.contractBalance = balanceStamp
        const res = await api.available({ userUid: this.form.userUid, accountType: this.form.accountType })
        if (version !== this.version) return
        if (balanceStamp && (balanceStamp.scope !== this.requestScope || balanceStamp.revision !== readRevision(balanceStamp.scope))) {
          this.invalidate(); this.availableError = '合约扣除状态已变化，请重新查询余额并确认'; return
        }
        if (!res || res.code !== 0 || !res.data) throw new Error(res && res.msg || '余额查询失败')
        this.balances = res.data
        this.availableLoaded = true
      } catch (error) { if (version === this.version) this.availableError = error.message || '余额查询失败' }
      finally { if (version === this.version) this.checking = false }
    },
    async submit() {
      if (!this.allowed || this.submitting || this.pending || this.checking || !this.availableLoaded) return
      if (!this.validateUid(this.form.userUid) || !this.form.accountType || !this.form.coin || !/^\d+(\.\d{1,4})?$/.test(this.form.amount)) return this.$message.error('请完整填写，金额最多4位小数')
      const amount = new Decimal(this.form.amount)
      if (amount.lte(0) || this.currentBalance === '--' || amount.gt(this.currentBalance)) return this.$message.error('扣除金额须大于0且不超过可扣余额')
      // Storage events can invalidate the form while confirmation or identity queries are pending.
      // Freeze the original intent; never rebuild a payload from that changed form after an await.
      const submission = { ...this.form, requestKey: this.requestKey }
      const balanceStamp = this.contractBalance
      // Separate ownership from balance invalidation: storage events clear the balance,
      // but late callbacks must still identify their original form/request.
      const contractOwner = submission.accountType === 'CONTRACT'
        ? { scope: this.requestScope, requestKey: submission.requestKey } : null
      if (contractOwner) this.contractRequestOwner = contractOwner
      this.submitting = true
      try { await this.$confirm('确认扣除该用户资产吗？操作后不可撤销，请谨慎操作。', '提示', { type: 'warning' }) }
      catch (_) { if (!contractOwner || this.ownsContractRequest(contractOwner)) this.submitting = false; return }
      let refreshAvailable = false
      let contractSaved = false
      try {
        if (contractOwner && !this.acceptContractResponse(contractOwner)) return
        if (!submission.requestKey) {
          const random = new Uint32Array(4); window.crypto.getRandomValues(random)
          submission.requestKey = Array.from(random).map(x => x.toString(16).padStart(8, '0')).join('')
        }
        this.requestKey = submission.requestKey
        if (contractOwner) contractOwner.requestKey = submission.requestKey
        if (submission.accountType === 'CONTRACT') {
          if (!await this.rememberContract(submission, 'new', balanceStamp, () => this.acceptContractResponse(contractOwner))) return
          contractSaved = true
          if (!this.acceptContractResponse(contractOwner)) return
        }
        const res = await api.deduct(submission)
        if (contractOwner && !this.acceptContractResponse(contractOwner)) return
        if (res && res.code !== 0) {
          this.$message.error(res.msg || '请求结果待确认，请刷新列表核查')
          this.pending = true
          return
        }
        if (!res || !res.data) throw new Error('请求结果待确认，请刷新列表')
        const op = res.data
        if (submission.accountType === 'CONTRACT' && op.accountType === 'CONTRACT'
          && op.submissionRejection === 'CONTRACT_BONUS_ACTIVE' && op.status === 'NOT_ACCEPTED'
          && op.id == null && op.dispatchState === 'NOT_SENT' && op.requestKey === submission.requestKey) {
          this.$message.error(op.message)
          // 仅明确的创建前拒绝可解锁；保留请求键，重试仍经过后端幂等检查。
          const requestKey = submission.requestKey
          await removeRequest(balanceStamp.scope, requestKey, false); this.readRecovery()
          if (!this.acceptContractResponse(contractOwner)) return
          this.invalidate(); this.requestKey = requestKey; this.pending = false
          this.availableError = op.message
        } else if (submission.accountType === 'CONTRACT') {
          if (op.accountType !== 'CONTRACT' || op.requestKey !== submission.requestKey || !op.id) throw new Error('原合约请求结果待确认，请核查原请求')
          const updated = await saveRequest(balanceStamp.scope, op, 'update'); this.readRecovery()
          if (!this.acceptContractResponse(contractOwner)) return
          if (!updated) throw new Error('原合约请求记录缺失，请核查原单，勿重新扣除')
          this.pending = true; this.visible = false
          this.$message.info(op.status === 'SUCCESS' ? '扣除成功，请核对原单结果' : op.message || '请核查原单结果')
          await this.showDetail(op.id, contractOwner)
        } else if (res.data.status === 'SUCCESS') { this.$message.success('扣除成功'); this.visible = false }
        else if (res.data.status === 'FAILED') { this.$message.error(res.data.message || '扣除未完成'); this.invalidate(); refreshAvailable = true }
        else { this.pending = true; this.$message.info('请求已受理，请在列表查看处理结果') }
      } catch (error) {
        if (!contractOwner || this.acceptContractResponse(contractOwner)) {
          this.pending = submission.accountType !== 'CONTRACT' || contractSaved
          this.$message.error(error.message || '请求结果待确认，请刷新列表')
        }
      } finally {
        if (!contractOwner || this.ownsContractRequest(contractOwner)) {
          this.submitting = false; this.load(); if (refreshAvailable) await this.fetchAvailable()
        }
      }
    },
  },
}
</script>
<style scoped>.abnormal-asset { background: #fff; padding: 24px; }.review-note { margin-top: 16px; }.el-pagination { margin-top: 20px; text-align: center; }</style>
